import React, { Component } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import { compose } from 'recompose'
import FontAwesome from 'react-fontawesome'

import withAuthorization from '../higherOrder/withAuthorization'
import { getDeviceList, setIdToken, resetIdToken } from '../../actions'
import { SENSOR_ADD } from '../../constants/routes'
import LoadingSpinner from '../Global/LoadingSpinner'
import { FillerDiv, CenteredDiv, DivWithMargin } from '../StyledComponents/Fillers'
import { DevicesRow, AddDeviceActionButton } from '../StyledComponents/Devices/DeviceList'
import TableViewCellTitle from '../Settings/TableViewCellTitle'
import TableViewCellDescription from '../Settings/TableViewCellDescription'
import NotFoundPage from './NotFound'

import SensorListItem from '../Devices/SensorListItem'
import ValveListItem from '../Devices/ValveListItem'

class DeviceListPage extends Component {
    componentDidMount() {
        this.loadDeviceList()
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.sessionState.idToken && !!this.props.sessionState.idToken) {
            this.loadDeviceList()
        }
    }

    loadDeviceList() {
        if (this.props.sessionState.idToken) {
            const { token } = this.props.sessionState.idToken
            this.props.getDeviceList(token)
        }
    }

    render() {
        const { deviceList, error } = this.props

        if (!deviceList || isEmpty(deviceList)) {
            if (error) {
                return <NotFoundPage />
            }
            return <CenteredDiv><LoadingSpinner /></CenteredDiv>
        }

        const sensors = deviceList.sensors.length > 0
            ? deviceList.sensors.map(device => (
                <SensorListItem sensor={device} key={device.uuid} />
            ))
            : <TableViewCellDescription text="Füge Sensoren hinzu, um die Daten anzeigen zu können." />

        const valves = deviceList.valves.length > 0
            ? deviceList.valves.map(device => (
                <ValveListItem device={device} key={device.uuid} />
            ))
            : <TableViewCellDescription text="Zur Zeit werden noch keine Ventile unterstützt" />

        const addSensorButton = (
            <AddDeviceActionButton to={SENSOR_ADD}>
                <FontAwesome name="plus" />
            </AddDeviceActionButton>
        )

        return (
            <FillerDiv>
                <TableViewCellTitle background="#fff" text="Sensoren" actionButton={addSensorButton} />
                <DevicesRow>{sensors}</DevicesRow>
                <TableViewCellTitle background="#fff" text="Ventile" />
                <DevicesRow>{valves}</DevicesRow>
                <DivWithMargin bottom="20" />
            </FillerDiv>
        )
    }
}

const authCondition = authUser => !!authUser

const mapStateToProps = state => ({
    deviceList: state.deviceList.list,
    error: state.deviceList.error,
    sessionState: state.sessionState,
})

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps, { getDeviceList, setIdToken, resetIdToken })
)(DeviceListPage)



// WEBPACK FOOTER //
// ./src/components/pages/DeviceList.js